import { ReferrerType } from '@farmersdog/coupons';

import type { AttributesContextualInfo } from '../types';

export function getCouponCode(context: AttributesContextualInfo): string {
  const {
    couponData: { couponCode, referrerType },
  } = context;
  return (referrerType === ReferrerType.Partner && couponCode) || '';
}
